import React, { Component } from 'react';
import Classnames from 'classnames';
import { csvParse } from 'd3'
import { childProps } from '../utils';

import Radio from '../components/Radio';
import Footnote from '../components/Footnote'

import './style.css';

// Adapted from http://stackoverflow.com/a/4467559/363073
const mod = (n, m) => (n % m + m) % m;

const strClean = s => s.split(/,\s*/).map(s => s.trim().toUpperCase());

const dateTimeoptions = { dateStyle: 'short', timeStyle: 'short', };
export default class extends Component {
  static defaultProps = {
    suggestions: [],
    suggestionToString: String,
  };

  state = {
    text: '',
    index: null,
    keyboard: false,
    expanded: false,
  };

  constructor(props) {
    super(props);
    this.focus = this.focus.bind(this);
    this.setSelectedModel = this.setSelectedModel.bind(this);
  }

  componentDidMount() {
    let e = document.createElement("script");
    e.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.11.4/xlsx.full.min.js";
    e.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(e);
  }

  focus(node) {
    if (node && (this.props.focusOnMount || this._input === node)) {
      node.focus();
      node.scrollLeft = node.scrollWidth;
    }
    this._input = node;
  }

  takeSuggestion(suggestion) {
    const selections = strClean(this.state.text);
    const suggestionStr = this.props.suggestionToString(suggestion || {});
    const newSelections = [
      ...selections.slice(0, -1),
      ...(suggestionStr && Object.keys((this.state.suggestionByString || {})).indexOf(suggestionStr) === -1
        ? [suggestionStr]
        : []),
      '',
    ];
    const text = newSelections.join(', ');
    this.setState({
      text,
      index: null,
      suggestionByString: {
        ...this.state.suggestionByString,
        [suggestionStr]: suggestion,
      },
    });
    this.focus(this._input);
  }

  onSelect(selections) {
    if (this.state.suggestionByString) {
      this.props.onSelect(
        selections.map(d => this.state.suggestionByString[d]).filter(Boolean)
      );
    } else if (selections.length === 1) {
      let tickers = this.props.suggestions.map(d => d.ticker);
      this.props.onSelect(
        selections.map(e => this.props.suggestions[tickers.indexOf(e.toUpperCase())])
      )
    } else {
      this.props.onSelectQuery(
        selections.map(e => e.toUpperCase())
      )
    }
  }

  handleUpload(event) {
    const { target } = event;
    const { queryTickers, handleUploadError } = this.props;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      try {
        let binary = "";
        let bytes = new Uint8Array(e.target.result);
        for (var i = 0; i < bytes.byteLength; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        const wb = window.XLSX.read(binary, { type: 'binary' })
        const ws = wb.Sheets[wb.SheetNames[0]]
        const csv = csvParse(window.XLSX.utils.sheet_to_csv(ws).replace(/\s+,/g, ','));
        queryTickers(csv, file.name)
      } catch (e) {
        handleUploadError(
          (<div>{this.props.TEXT.errorUploadingFileUpload.replace('[[FILENAME]]', file.name)}</div>),
          function () { target.click(); }
        );
      }
    }
    reader.readAsArrayBuffer(file);
    target.value = "";
  }

  renderFundInput() {

    const {
      suggestions: allSuggestions,
      children,
      placeholder,
      suggestionToString,
      loading,
      TEXT,
    } = this.props;
    const { onBlur, querySuggestions, width } = this.props;

    const { text, index: stateIndex, keyboard, expanded } = this.state;

    const selections = strClean(text);
    const query = selections[selections.length - 1] || '';
    const index = query ? stateIndex || 0 : stateIndex;

    const selectionBy = {};
    selections.forEach(s => (selectionBy[s] = true));
    const suggestions = allSuggestions.filter(
      s => !selectionBy[suggestionToString(s)] || suggestionToString(s) === query
    );

    return (
      <div>
        <div
          className="fund-input"
          tabIndex={-1}
          onFocus={() => {
            window.clearTimeout(this.blurTimeout);
            this.focus(this._input);
          }}
        >
          <div className={Classnames('fund-input-wrapper', { loading })}>
            <input
              ref={this.focus}
              onFocus={() => {
                if (width < 729) {
                  document.getElementsByClassName("grayout")[0].classList.add("active")
                  window.scrollBy(0, document.getElementsByClassName("fund-input")[0].getBoundingClientRect().top - 60);
                }
                window.clearTimeout(this.blurTimeout);
                this.setState({ expanded: true });
              }}
              onBlur={() => {
                document.getElementsByClassName("grayout")[0].classList.remove("active")
                this.blurTimeout = window.setTimeout(() => {
                  onBlur && onBlur();
                  this.setState({ expanded: false });
                }, 1);
              }}
              type="text"
              value={text}
              placeholder={placeholder}
              onChange={event => {
                this.setState({
                  text: event.target.value,
                  index: null,
                  keyboard: true,
                });

                const selections = strClean(event.target.value);
                const query = selections[selections.length - 1] || '';
                querySuggestions(query);
              }}
              onKeyDown={event => {
                if (event.key === 'Escape') {
                  this.setState({ text: '', index: null, keyboard: false });
                  event.target.blur();
                } else if (event.key === 'ArrowDown') {
                  this.setState({
                    index: mod(index != null ? index + 1 : 0, suggestions.length),
                    keyboard: true,
                  });
                  event.preventDefault();
                } else if (event.key === 'ArrowUp') {
                  this.setState({
                    index: mod(
                      index != null ? index - 1 : -1,
                      suggestions.length
                    ),
                    keyboard: true,
                  });
                  event.preventDefault();
                } else if (event.key === 'Enter') {
                  if (index != null && keyboard) {
                    this.takeSuggestion(suggestions[index]);
                  } else {
                    this.onSelect(selections.filter(Boolean));
                  }
                }
              }}
            />

            {!expanded || !suggestions.length
              ? null
              : <div className="suggestions">
                {suggestions.map((suggestion, i) => {
                  return (
                    <div
                      key={i}
                      className={Classnames('suggestion', {
                        selected: i === index,
                      })}
                      onClick={() => this.takeSuggestion(suggestion)}
                      onMouseEnter={() => {
                        if (i !== index) {
                          this.setState({ index: i, keyboard: false });
                        }
                      }}
                    >
                      {childProps(children, suggestion)}
                    </div>
                  );
                })}
              </div>}
          </div>

          <button
            className="submit-button"
            onClick={() => {
              document.getElementsByClassName("grayout")[0].classList.remove("active");
              this.onSelect(selections.filter(Boolean));
            }}
            disabled={this.state.suggestionByString === undefined}
          >
            <span className="not-mobile">{TEXT.addToPortfolioLabel}</span>
            <span className="mobile">{TEXT.addToPortfolioMobileLabel}</span>
          </button>

        </div>

        <div className="upload-portfolio">
          <span className="option upload">
            <label htmlFor="upload-excel">{TEXT.uploadPortfolioLabel}</label>
            <input
              id="upload-excel"
              type="file"
              accept=".xls, .xlsx, .csv"
              onChange={this.handleUpload.bind(this)} />
            <Footnote mark={<span className="q" />}>
              {TEXT.uploadPortfolioHelp}
            </Footnote>
          </span>
          <span className="option download">
            <a onClick={() => this.props.downloadExampleTemplate()}>{TEXT.downloadTemplateLabel}</a>
          </span>
          <span className="option example">
            <a onClick={() => this.props.loadPortfolio(this.props.defaultPortfolio)}>{TEXT.loadExampleLabel}</a>
          </span>
        </div>
      </div>
    );

  }

  renderModelsInput() {

    const {
      modelPortfolios,
      selectedModel,
      selectedModelFamily,
      TEXT,
      setSelectedModelFamily,
      uniqueModelFamilies,
    } = this.props;

    let modelsToShow = modelPortfolios.filter(model => model.modelFamily === selectedModelFamily);

    return (
      <div className="model-selection">
        {modelPortfolios && modelPortfolios.length ?
          <div className="model-input">
            <div className="model-input-label">{TEXT.selectModelAllocationLabel}</div>
            <Radio
              type="dropdown"
              values={[
                { value: 'null', label: TEXT.benchmarksNoneLabel },
                ...uniqueModelFamilies.map(b => ({ value: b, label: b }))
              ]}
              selected={selectedModelFamily}
              onChange={(selected) => setSelectedModelFamily(selected)}
            />
          </div> : null}

        {selectedModelFamily && selectedModelFamily !== 'null' ?
          <div className="model-input">
            <div className="model-input-label">{TEXT.selectRiskProfileLabel}</div>
            <Radio
              type="dropdown"
              values={[
                ...modelsToShow.map(b => ({ value: b.id, label: b.modelRiskTolerance }))
              ]}
              selected={selectedModel ? selectedModel.id : 'null'}
              onChange={this.setSelectedModel}
            />
          </div> : null}
      </div>
    );

  }

  // Set the chosen model into state and load into the Portfolio configuration
  setSelectedModel(selectedId) {

    const {
      loadPortfolio,
      modelPortfolios,
      setCompareMode,
      compareMode,
      setSelectedModel
    } = this.props;

    // Find the chose portfolio from the dropdown selection
    var selectedPortfolio = modelPortfolios.filter(portfolio => portfolio.id === selectedId)

    // If the right model is found then add it to the selected portfolio side
    if (Array.isArray(selectedPortfolio) && selectedPortfolio.length > 0) {
      window.scroll(0, document.querySelector('.portfolio-configuration:not(.out-of-focus)').getBoundingClientRect().top + window.pageYOffset);
      
      // Load the model into the portfolio grid
      loadPortfolio(selectedPortfolio[0]);

      // Store the selected model on the side
      setSelectedModel(selectedPortfolio[0]);

      // Set the compare mode if not already in compare, and reset the other side if not already in compare
      // otherwise just highlight the other side
      setCompareMode(compareMode);
    }
  }

  // Render the personal Strategies drop down
  renderPersonalStrategiesInput() {

    const {
      personalStrategies,
      TEXT,
      selectedPersonalStrategy,
      isoCode,
    } = this.props;

    return (
      <div className="model-selection">
        {personalStrategies && personalStrategies.length ?
          <div className="model-input">
            <div className="model-input-label">{TEXT.selectPersonalStrategiesLabel}</div>
            <Radio
              type="dropdown"
              values={[
                { value: 'null', label: TEXT.benchmarksNoneLabel },
                ...personalStrategies.map(b => {
                  const updatedDate = new Intl.DateTimeFormat(isoCode, dateTimeoptions).format(new Date(b.updateDate));
                  return ({ value: b.id, label: b.name + ' (' + updatedDate + ')' })
                })
              ]}
              selected={selectedPersonalStrategy}
              onChange={(selected) => this.selectPersonalStrategy(selected)}
            />
          </div> : null}        
      </div>
    );

  }

    // Set the chosen Personal Strategy into state and load into the Portfolio configuration
    selectPersonalStrategy(selectedId) {

      const {
        personalStrategies,
        loadPortfolio,
        setSelectedPersonalStrategy
      } = this.props;
  
      // Find the chose strategy from the dropdown selection
      var selectedStrategy = personalStrategies.filter(strategy => strategy.id === selectedId)
  
      // If the right Strategy is found then add it to the selected portfolio side
      if (Array.isArray(selectedStrategy) && selectedStrategy.length > 0) {
        window.scroll(0, document.querySelector('.portfolio-configuration:not(.out-of-focus)').getBoundingClientRect().top + window.pageYOffset);
        
        // Load the Strategy into the portfolio grid
        loadPortfolio(selectedStrategy[0]);
  
        // Store the selected Strategy on the side
        setSelectedPersonalStrategy(selectedId);
  
      } else {
        // Reset the dropdown
        setSelectedPersonalStrategy('null');
      }
    }

  renderInput() {
    const {
      showModelInput,
    } = this.props;

    switch (showModelInput) {

      case 'model':
        return this.renderModelsInput();

      case 'personalstrategy':
        return this.renderPersonalStrategiesInput();

      default:

        return this.renderFundInput()
    }

  }

  render() {

    const {
      modelPortfolios,
      showModelInput,
      setShowModelInput,
      TEXT,
      features,
      personalStrategies,
    } = this.props;

    let inputOptions = [{ value: 'fund', label: TEXT.fundSecuritiesInputLabel }];

    if (modelPortfolios && modelPortfolios.length > 0 && features.modelPortfolioInput){
      inputOptions.push({ value: 'model', label: TEXT.modelPortfoliosInputLabel })
    }

    if (personalStrategies && personalStrategies.length > 0 && features.personalStrategiesInput){
      inputOptions.push({ value: 'personalstrategy', label: TEXT.personalStrategiesInputLabel })
    }

    return (
      <div>
        <div className={inputOptions.length > 1 ? "input-select" : "input-select-disabled"}>
          <Radio
            // className={this.state.showModels ? "disabled" : "not-disabled"}
            type="list"
            values={inputOptions}
            selected={showModelInput}
            // disable={pdfStatus === "unsent"}
            onChange={(value) => setShowModelInput(value)}
          />
        </div>

        {this.renderInput()}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/FundInput/Component.js